// @flow
import CafeteriaPurchases from './CafeteriaPurchases';

export default CafeteriaPurchases;
